import IntranetLayout from "@/components/IntranetLayout";
import ModuleHeader from "@/components/voff/ModuleHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Sparkles, Star } from "lucide-react";
import { toast } from "sonner";

const ELEMENTS = [
  { num: 1, name: "Management & Accountability", score: 85, status: "MET" },
  { num: 2, name: "Safety Culture & Leadership", score: 82, status: "MET" },
  { num: 3, name: "Competency & Training", score: 73, status: "GAP" },
  { num: 4, name: "Vessel Management", score: 90, status: "MET" },
  { num: 5, name: "Cargo Operations", score: 0, status: "N/A" },
  { num: 6, name: "Emergency Response", score: 78, status: "MET" },
  { num: 7, name: "Environmental Management", score: 76, status: "MET" },
  { num: 8, name: "Occupational Health", score: 65, status: "GAP" },
  { num: 9, name: "Drug & Alcohol", score: 92, status: "MET" },
  { num: 10, name: "Security", score: 80, status: "MET" },
  { num: 11, name: "Subcontractor Management", score: 70, status: "GAP" },
  { num: 12, name: "Performance Monitoring", score: 40, status: "CRITICAL GAP" },
  { num: 13, name: "Voyage Management", score: 77, status: "MET" },
];
const overall = Math.round(ELEMENTS.filter(e => e.status !== "N/A").reduce((a, e) => a + e.score, 0) / ELEMENTS.filter(e => e.status !== "N/A").length);

const OVMSAAssessment = () => (
  <IntranetLayout>
    <ModuleHeader title="OVMSA2 Assessment" subtitle="Offshore Vessel Management Self-Assessment — Client Prequalification"
      stats={[{ label: "Overall", value: `${overall}%`, tone: overall >= 80 ? "good" : "alert" }, { label: "Elements", value: "9/13" }, { label: "Client-ready", value: "PARTIAL", tone: "alert" }]}
      actions={<div className="flex items-center gap-1"><Star className="w-4 h-4 text-[#E8A020] fill-[#E8A020]" /><Star className="w-4 h-4 text-[#E8A020] fill-[#E8A020]" /></div>} />

    <div className="grid lg:grid-cols-12 gap-4">
      <Card className="lg:col-span-4 border-[#D0DDE6] h-fit"><CardContent className="p-4">
        <h3 className="font-bold text-sm text-[#00283C] mb-3">All 13 Elements</h3>
        <div className="space-y-2">{ELEMENTS.map(e => (
          <div key={e.num} className="text-xs">
            <div className="flex justify-between"><span><span className="font-mono text-[#6B8A9A]">{e.num}.</span> {e.name}</span><span className="font-bold">{e.status === "N/A" ? "N/A" : `${e.score}%`}</span></div>
            {e.status !== "N/A" && <Progress value={e.score} className="h-1 mt-0.5" />}
          </div>
        ))}</div>
      </CardContent></Card>

      <div className="lg:col-span-8 space-y-4">
        <Card className="border-[#C83228] border-l-4"><CardContent className="p-5">
          <div className="flex justify-between items-start mb-2"><div><div className="text-xs text-[#C83228] uppercase font-bold">Critical Gap</div><div className="font-bold text-[#00283C]">Element 12 — Performance Monitoring (40%)</div></div><Badge className="bg-[#C83228] text-white">CRITICAL</Badge></div>
          <p className="text-sm text-[#0D1E2B] mb-3">VOFF lacks a documented KPI tracking framework. Auditors expect monthly performance dashboards, root-cause analysis of misses, and trend reporting to leadership.</p>
          <div className="bg-[#288CC8]/5 p-3 rounded text-xs"><div className="font-bold text-[#288CC8] mb-1 flex items-center gap-1"><Sparkles className="w-3 h-3" />AI Recommendation</div>Use Financial Pulse and HSE Suite as the data backbone. Build a monthly KPI export (utilisation, TRIR, incident closure rate, drill compliance, certificate compliance, charter performance) and document it as VOH-OPS-PMM-001. Estimated effort: 3 days.</div>
        </CardContent></Card>

        <Card className="border-[#D0DDE6]"><CardContent className="p-5">
          <h3 className="font-bold text-[#00283C] mb-3">VOFF OVMSA2 Readiness Report</h3>
          <div className="bg-[#F4F7FA] p-4 rounded font-mono text-xs whitespace-pre text-[#0D1E2B]">
{`Overall Score:               ${overall}% (Target: 80% for ExxonMobil)
Elements meeting threshold:  9/13
Critical gaps:               Element 12 (40%)

ESTIMATED TIME TO CLIENT-READY:
ExxonMobil (80%):  ~6 weeks of focused effort
Azule Energy (75%): ~3 weeks

TOP 5 ACTIONS TO CLOSE GAPS:
1. Element 12 — KPI tracking framework        (3 days)
2. Element 3.1 — Competency assessment records (1 day)
3. Element 8 — Occupational health procedure   (1 day)
4. Element 11 — Subcontractor evaluation form  (½ day)
5. Element 6 — Upload drill records as evidence (1 hour)`}
          </div>
          <Button onClick={() => toast.success("Generating: Export OVMSA2 Report (Client-Submission Ready)", { description: "Your file will download shortly." })} className="mt-3 bg-[#288CC8] text-white">Export OVMSA2 Report (Client-Submission Ready)</Button>
        </CardContent></Card>
      </div>
    </div>
  </IntranetLayout>
);
export default OVMSAAssessment;
